<template>
  <body>
    <div class="top">
      <div class="topContent">
        <div class="topText1" @click="goback()">&lt; 返回</div>
        <div class="topText2">{{ name }}</div>
        <div class="topText3" v-if="!classBack">上一课</div>
        <div class="topText3" style="background: #C49760;" v-if="classBack" @click="goClassBack()">上一课</div>
        <div class="topText4" v-if="classNext" @click="goClassNext()">下一课</div>
        <div class="topText4" style="background: #CCCCCC;" v-if="!classNext">下一课</div>
      </div>
    </div>
    <div class="timeLeft" v-if="haveTime==1&&mode!=2">
      <div class="timeLeftText1">
          您当前的学习模式：集训营模式 ( 剩余有效学时：<span style="font-family:PingFang SC;font-weight: 600;">{{djsDay}}</span>&nbsp; 天 &nbsp;<span style="font-family:PingFang SC;font-weight: 600;">{{djsHour}}</span>&nbsp; 小时 &nbsp;<span style="font-family:PingFang SC;font-weight: 600;">{{djsMin}}</span>&nbsp; 分钟 &nbsp;<span style="font-family:PingFang SC;font-weight: 600;">{{djsSecond}}</span>&nbsp; 秒  ) 
      </div>
      <div class="changeMode" @click="shadow=1;dajishiOn()">
          <div class="changeModeText1">切换至自主学习模式</div>
          <img src="~@/assets/globalCourse/白色箭头.png" alt="" class="changeModeIcon">
      </div>
    </div>
    <div class="timeLeft" v-if="haveTime==2&&mode!=2">
        <div class="timeLeftText1">
            您的有效学时已用尽，无法申请证书，但您可以继续学习
        </div>
        <div class="changeMode" @click="shadow=1;dajishiOn()">
            <div class="changeModeText1">切换至自主学习模式</div>
            <img src="~@/assets/globalCourse/白色箭头.png" alt="" class="changeModeIcon">
        </div>
    </div>
    <div class="timeLeft" v-if="haveTime==3&&mode!=2" @click="$router.push('/graduationCertificate')">
        您已结业！<span style="cursor: pointer;">申请结业证书</span>
        <img src="~@/assets/globalCourse/白色箭头.png" alt="" class="timeLeftIcon">
    </div>
    <div class="timeLeft" v-if="haveTime==4&&mode!=2">您已完成全部学习内容</div>
    <div class="timeLeft" v-if="mode==2">您当前为自主学习模式，可自由选择课程任意部分学习</div>

    <div class="shadow" v-if="shadow == 1">
      <div class="shadowContent">
          <img src="~@/assets/globalCourse/关闭.png" alt="" class="shadowIcon" @click="shadow=0;reDaojishi()">
          <div class="shadowText1">切换自主学习模式提示</div>
          <div class="shadowText2">当您切换至自主学习模式后，可自由安排学习计划，无时限和作业要求，也可根据自己的兴趣和需求自由选择课程内容，学习过程可自定进度。<br>
              <span style="color:#FF6666 ;">请知悉：自主学习模式下不支持切换回集训营模式，且不提供结业证书。</span>
          </div>
          <div class="shadowButton1" v-if="waiting">确定切换 ({{ second }}s)</div>
          <div class="shadowButton1-s" v-if="!waiting" @click="exchangeMode()">确定切换</div>
          <div class="shadowButton2" @click="shadow=0;reDaojishi()">我再想想</div>
      </div>
  </div>
    <div class="video">
      <video width="960px" height="540px" controls="controls" controlslist="nodownload" :src="VideoUrl" preload="preload"
        id="videoId"></video>
    </div>
  </body>
</template>
<script>
export default {
  name: "coursePlay",
  data() {
    return {
      videoId: "",
      name: "",
      VideoUrl: "",
      originTime: 0,
      currentTime: 0,
      timer: '',//计时器
      timerUp: '',//计时器
      status: 0,
      videoListLength: 0,
      index: 0,
      classBack: false,
      classNext: true,
      videoList: [],
      //倒计时
      djsDay: 89,
      djsHour: 23,
      djsMin: 59,
      djsSecond: 59,
      //首次学习
      firstStatus: 0,
      haveTime: 0,
      timer1: '',
      //记录完成发送时间
      videoFinish: 0,
      //总时长
      duration: 0,
      timeFinish: '',
      //模式
      mode:0,
      shadow:0,
      second: 5,
      waiting: true,
      timerTip: "",
    };
  },
  methods: {
    getKey() {
      return localStorage.getItem("token");
    },
    goLogin() {
      let url = "/coursePlay?videoId=" + this.videoId;
      this.$router.push({ path: "/Login?returnUrl=" + url })
    },
    goback() {
      this.timeSubmit()
    },
    goClassBack() {
      var vd = document.getElementById("videoId");
      let status = -1
      if (this.status == 0) {
        if (vd.duration - vd.currentTime < 1) {
          if (vd.currentTime < 1 || vd.duration < 1 || isNaN(vd.duration) == false) {
            status = 0
          } else {
            status = 1
          }
        } else {
          status = 0
        }
      } else {
        status = 1
      }
      if (!this.$store.state.user.logined) {
        //判断当this.$store.state.user.logined=false但是用户确实登录的状态
        this.axios.get("/loginapi/getLoginInfo", {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }).then((res) => {
          if (res.data.success) {
            this.$store.state.user.logined = true;
            var userInfo = {
              "videoId": this.videoId,
              "learnRate": vd.currentTime,
              "learnStatus": status,
            }
            this.axios.post(
              "/learn_back/course/courseLearn/sendVideoLastLearnInfo", userInfo,
              {
                headers: {
                  Authorization: "Bearer " + this.getKey(),
                },
              }
            )
              .then((res) => {
                console.log(res);
                let resData = res.data;
                if (resData.code != 200) {
                  console.log("获取视频时间失败")
                } else {
                  console.log("获取视频成功1", 'videoId', this.videoList[this.index - 1].id, 'videoList', this.videoList, 'index', this.index - 1);
                  this.$router.push({ path: '/coursePlay', query: { 'videoId': this.videoList[this.index - 1].id, 'videoList': this.videoList, 'index': this.index - 1 } });
                }
              });
          } else {
            this.goLogin()
          }
        })
      } else {
        var userInfo = {
          "videoId": this.videoId,
          "learnRate": vd.currentTime,
          "learnStatus": status,
        }
        this.axios.post(
          "/learn_back/course/courseLearn/sendVideoLastLearnInfo", userInfo,
          {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }
        )
          .then((res) => {
            let resData = res.data;
            if (resData.code != 200) {
              console.log("获取视频时间失败")
            } else {
              console.log("获取视频成功2", 'videoId', this.videoList[this.index - 1].id, 'videoList', this.videoList, 'index', this.index - 1);
              this.$router.push({ path: '/coursePlay', query: { 'videoId': this.videoList[this.index - 1].id, 'videoList': this.videoList, 'index': this.index - 1 } });
            }
          });

      }
    },
    goClassNext() {
      var vd = document.getElementById("videoId");
      let status = -1
      if (this.status == 0) {
        if (vd.duration - vd.currentTime < 1) {
          if (vd.currentTime < 1 || vd.duration < 1 || isNaN(vd.duration) == false) {
            status = 0
          } else {
            status = 1
          }
        } else {
          status = 0
        }
      } else {
        status = 1
      }
      if (!this.$store.state.user.logined) {
        //判断当this.$store.state.user.logined=false但是用户确实登录的状态
        this.axios.get("/loginapi/getLoginInfo", {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }).then((res) => {
          if (res.data.success) {
            this.$store.state.user.logined = true;
            var userInfo = {
              "videoId": this.videoId,
              "learnRate": vd.currentTime,
              "learnStatus": status,
            }
            this.axios.post(
              "/learn_back/course/courseLearn/sendVideoLastLearnInfo", userInfo,
              {
                headers: {
                  Authorization: "Bearer " + this.getKey(),
                },
              }
            )
              .then((res) => {
                let resData = res.data;
                if (resData.code != 200) {
                  console.log("获取视频时间失败")
                } else {
                  console.log("获取视频成功3", 'videoId', this.videoList[Number(Number(this.index) + 1)].id, 'videoList', this.videoList, 'index', Number(Number(this.index) + 1));
                  this.$router.push({ path: '/coursePlay', query: { 'videoId': this.videoList[Number(Number(this.index) + 1)].id, 'videoList': this.videoList, 'index': Number(Number(this.index) + 1) } });
                }
              });
          } else {
            this.goLogin()
          }
        })
      } else {
        var userInfo = {
          "videoId": this.videoId,
          "learnRate": vd.currentTime,
          "learnStatus": status,
        }
        this.axios.post(
          "/learn_back/course/courseLearn/sendVideoLastLearnInfo", userInfo,
          {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }
        )
          .then((res) => {
            let resData = res.data;
            if (resData.code != 200) {
              console.log("获取视频时间失败")
            } else {
              console.log("获取视频成功4", 'videoId', this.videoList[Number(Number(this.index) + 1)].id, 'videoList', this.videoList, 'index', Number(Number(this.index) + 1));
              this.$router.push({ path: '/coursePlay', query: { 'videoId': this.videoList[Number(Number(this.index) + 1)].id, 'videoList': this.videoList, 'index': Number(Number(this.index) + 1) } });
            }
          });

      }
    },
    getVideo() {
      this.videoId = this.$route.query.videoId;
      if (this.videoId != undefined && this.videoId != '' && this.videoId != null) {
        localStorage.setItem('videoId', this.videoId)
      }
      this.videoList = this.$route.query.videoList;
      console.log("this.$route.query.videoList", this.$route.query.videoList);
      if (this.videoList[0].courseId != undefined && this.videoList[0].courseId != null) {
        localStorage.setItem('videoList', JSON.stringify(this.videoList))
      }
      if (this.videoId == undefined || this.videoId == '' || this.videoId == null) {
        this.videoId = localStorage.getItem('videoId')
      } else {
        this.videoId = this.$route.query.videoId;
      }
      if (this.videoList[0].courseId == undefined || this.videoList[0].courseId == null) {
        this.videoList = JSON.parse(localStorage.getItem('videoList'))
      } else {
        this.videoList = this.$route.query.videoList;
      }
      this.videoListLength = this.videoList.length
      this.index = this.$route.query.index;
      if (this.index != undefined && this.index != '' && this.index != null) {
        localStorage.setItem('index', this.index)
      }
      if (this.index == undefined || this.index == '' || this.index == null) {
        this.index = localStorage.getItem('index')
      } else {
        this.index = this.$route.query.index;
      }
      if (this.index != 0) {
        this.classBack = true
      }
      if (this.index == this.videoListLength - 1) {
        this.classNext = false
      }
      this.axios.get(
        "/learn_back/course/video/getVideoLastLearnInfo/" + this.videoId,
        {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }
      )
        .then((res) => {
          let resData = res.data;
          if (resData.code != 200) {
            alert("课程暂无视频");
          } else {
            this.name = resData.data.title
            this.VideoUrl = resData.data.url
            var vd = document.getElementById("videoId");
            vd.currentTime = resData.data.learnRate
            this.status = resData.data.learnStatus
            if (this.status == 0 && this.$store.state.mode!=2) {
              this.banJinDuTiao()
            }
          }
        });
    },
    banJinDuTiao() {
      var tarr = [];
      var video = document.querySelector("video");
      video.addEventListener("timeupdate", function (e) {
        // console.log("timeupdate",video.currentTime);
        tarr.unshift(video.currentTime);
        tarr.length = 5;
        if (tarr[0] - tarr[5] > 0.25) {
          video.currentTime = tarr[5]
        }
      }, false);
      video.addEventListener("seeking", function (e) {
        // console.log("seeking",video.currentTime);
        if (video.currentTime > tarr[1]) {//不知道你说的向前和向后是指什么方向，方向不对的话把 < 改成 >
          video.currentTime = tarr[1];
        }
      }, false);
      let that = this
      var vd = document.getElementById("videoId");
      that.originTime = vd.currentTime
      that.timer = setInterval(function () {
        that.currentTime = vd.currentTime
        const currentTime = vd.currentTime
        if (currentTime - that.originTime > 2) {
          vd.currentTime = that.originTime
        }
        that.originTime = currentTime
      }, 100)
    },
    timeSubmit() {
      var vd = document.getElementById("videoId");
      let status = -1
      if (this.status == 0) {
        if (vd.duration - vd.currentTime < 0.5) {
          if (vd.currentTime < 1 || vd.duration < 1 || isNaN(vd.duration) == false) {
            status = 0
          } else {
            status = 1
          }
        } else {
          status = 0
        }
      } else {
        status = 1
      }
      // console.log(vd.currentTime)
      var userInfo = {
        "videoId": this.videoId,
        "learnRate": vd.currentTime,
        "learnStatus": status,
      }
      this.axios.post(
        "/learn_back/course/courseLearn/sendVideoLastLearnInfo", userInfo,
        {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }
      )
        .then((res) => {
          let resData = res.data;
          if (resData.code != 200) {
            console.log("获取视频时间失败")
          } else {
            console.log("获取视频时间成功")
            let courseId = localStorage.getItem("courseId");
            this.$router.push({ path: '/courseShow', query: { 'courseId': courseId } })
          }
        });

    },
    timeIn() {
      let that = this
      var vd = document.getElementById("videoId");
      let status = -1
      if (that.status == 0) {
        if (vd.duration - vd.currentTime < 1) {
          if (vd.currentTime < 1 || vd.duration < 1 || isNaN(vd.duration) == false) {
            status = 0
          } else {
            status = 1
          }
        } else {
          status = 0
        }
      } else {
        status = 1
      }
      if (that.$store.state.user.logined) {
        let param = new FormData();
        param.append("token", localStorage.getItem("token").toString());
        param.append("videoId", this.videoId.toString())
        param.append("learnRate", vd.currentTime.toString())
        param.append("learnStatus", status.toString())
        var url = '/loginapi/course/courseLearn/sendVideoLastLearnInfoFD'
        const joinedQueue = window.navigator.sendBeacon(url, param)
        console.log('用户代理把数据加入传输队列' + (joinedQueue ? '成功' : '失败'));
      } else {
        that.goLogin()
      }
    },
    firstStudy() {
      this.axios.post(
        "/learn_back/course/courseLearn/sendUserFirstLearnStatus/" + this.status, null,
        {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }
      )
        .then((res) => {
          let resData = res.data;
          if (resData.code != 200) {
            console.log("获取用户信息失败")
          } else {
            //mode 0 集训营 1 线下 2 自主学习
            this.mode=resData.data.mode

            this.firstStatus = resData.data.firstLearnStatus
            this.djsDay = resData.data.remainLearnTime[0]
            this.djsHour = resData.data.remainLearnTime[1]
            this.djsMin = resData.data.remainLearnTime[2]
            this.djsSecond = resData.data.remainLearnTime[3]
            let totalLearnStatus = resData.data.totalLearnStatus
            if (totalLearnStatus == 0) {
              if (this.firstStatus == 0) {
                this.haveTime = 0
              } else if (this.firstStatus == 1) {
                if (this.djsDay < 0 || this.djsHour < 0 || this.djsMin < 0 || this.djsSecond < 0) {
                  this.haveTime = 2
                } else if (this.djsDay == 0 && this.djsHour == 0 && this.djsMin == 0 && this.djsSecond == 0) {
                  this.haveTime = 2
                } else {
                  this.haveTime = 1
                  this.effectiveTimeOn()
                }
              }
            } else if (totalLearnStatus == 1) {
              this.haveTime = 3
            } else {
              this.haveTime = 4
            }
          }
        });
    },
    effectiveTime() {
      if (this.djsDay == 0 && this.djsHour == 0 && this.djsMin == 0 && this.djsSecond == 0) {
        this.haveTime = 2
        clearInterval(this.timer1);
      } else {
        if (this.djsSecond <= 0) {
          this.djsSecond = 59
          if (this.djsMin <= 0) {
            this.djsMin = 59
            if (this.djsHour <= 0) {
              this.djsHour = 23
              if (this.djsDay < 0) {
                this.haveTime = 2
                clearInterval(this.timer1);
              } else {
                this.djsDay--
              }
            } else {
              this.djsHour--
            }
          } else {
            this.djsMin--
          }
        } else {
          this.djsSecond--
        }
      }
    },
    effectiveTimeOn() {
      this.$nextTick(() => {
        this.timer1 = setInterval(this.effectiveTime, 1000);
      });
    },
    daojishi() {
      if (this.second <= 0) {
          this.waiting = false;
          clearInterval(this.timerTip);
      } else {
          this.second--;
      }
    },
    dajishiOn() {
      this.$nextTick(() => {
          this.timerTip = setInterval(this.daojishi, 1000);
      });
    },
    reDaojishi(){
      this.waiting=true
      this.second=5
      clearInterval(this.timerTip)
    },
    exchangeMode(){
      var userInfo = {
        education: '硕士',
        age: '27',
        sex: '1',
        major: "计算机科学与技术",
        company: "长光卫星",
        email: "121@qq.com"
      }
      this.axios.post(
        "/learn_back/course/register/saveFreeLearnCourseRegister", userInfo,
        {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }
      ).then((res) => {
         console.log(res);
         this.mode=2
         this.shadow=0
        });
    }

  },
  mounted() {
    let that = this
    var video = document.getElementById("videoId");
    that.timeFinish = setInterval(function () {
      that.videoFinish = video.currentTime
      that.duration = video.duration
    }, 500)

    this.getVideo()
    this.firstStudy()
    // 禁止使用右键和f12
    window.addEventListener("beforeunload", e => this.timeIn());
    this.$nextTick(() => {
      document.oncontextmenu = function () {
        return false
      }
    })
    document.onkeydown = function (e) {
      if (e && e.keyCode === 123) {
        e.returnValue = false
        return false
      }
    }


  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
    clearInterval(this.timerUp)
    this.timerUp = null
  },
  destroyed() {
    window.removeEventListener("beforeunload", e => this.timeIn());
  },
  watch: {
    videoFinish: {
      handler(val) {
        let status = -1
        if (this.duration - val < 0.5) {

          if (val < 0.001) {
            status = 0
          } else {
            status = 1
          }
        }
        if (status == 1) {
          clearInterval(this.timeFinish)
          var userInfo = {
            "videoId": this.videoId,
            "learnRate": val,
            "learnStatus": status,
          }
          this.axios.post(
            "/learn_back/course/courseLearn/sendVideoLastLearnInfo", userInfo,
            {
              headers: {
                Authorization: "Bearer " + this.getKey(),
              },
            }
          )
            .then((res) => {
              let resData = res.data;
              if (!resData.success) {
                console.log("获取视频时间失败")
              } else if (resData.success) {
                console.log("获取视频时间成功")
              }
            });
        }

      }
    },
    '$route'(to,from){
      this.$router.go(0);
    }

  }
};
</script>
<style scoped>
.top {
  position: relative;
  width: 100%;
  height: 76px;
  background: #FFFFFF;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.topContent {
  position: absolute;
  width: 1280px;
  height: 76px;
  left: calc(50% - 640px);
}

.topText1 {
  position: absolute;
  left: 0;
  width: 80px;
  height: 76px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #3A3A3A;
  line-height: 76px;
  cursor: pointer;
}

.topText2 {
  position: absolute;
  width: 500px;
  left: calc(50% - 250px);
  height: 76px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 76px;
  text-align: center;
}

.topText3 {
  position: absolute;
  top: 18px;
  right: 128px;
  width: 112px;
  height: 40px;
  background: #CCCCCC;
  border-radius: 20px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.topText4 {
  position: absolute;
  top: 18px;
  right: 0;
  width: 112px;
  height: 40px;
  background: #C49760;
  border-radius: 20px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.video {
  /* position: relative; */
  margin-top: 100px;
  margin-left: calc(50% - 480px);
  width: 960px;
  height: 540px;
  background: #D8D8D8;
  margin-bottom: 300px;
}

.timeLeft {
  position: relative;
  margin-top: 0px;
  margin-bottom: 0px;
  width: 100%;
  height: 40px;
  background: #C49760;
  font-size: 14px;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
}

.timeLeftIcon {
  position: absolute;
  top: 15px;
  left: calc(50% + 85px);
  width: 6px;
  height: 10px;
  cursor: pointer;
}

.timeLeftText1 {
  position: absolute;
  width: 600px;
  height: 40px;
  left: calc(50% - 300px);
}

.timeLeftText2 {
  position: absolute;
  width: 330px;
  height: 40px;
  left: 0;
  /* background-color: pink; */
  font-size: 14px;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: #FFFFFF;
  line-height: 40px;
  text-align: left;
}

.timeLeftText3 {
  position: absolute;
  left: 125px;
  width: 20px;
  height: 40px;
  /* background-color: pink; */
  font-family: PingFang SC;
  font-weight: 600;
  line-height: 40px;
  text-align: right;
}

</style>
<style scoped>
.changeMode{
    position: absolute;
    left: calc(50% + 460px);
    top: 5px;
    width: 180px;
    height: 30px;
    background: #C49760;
    border-radius: 15px;
    border: 1px solid #FFFFFF;
    cursor: pointer;
}
.changeModeText1{
    position: absolute;
    top: 8px;
    left: 21px;
    width: auto;
    height: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 14px;
}
.changeModeIcon{
    position: absolute;
    top: 9px;
    left: 153px;
    width: 6px;
    height: 12px;
}
.shadow{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10000;
    backdrop-filter: blur(2px);
}
.shadowContent{
    position: absolute;
    top: calc(50% - 200px);
    left: calc(50% - 400px);
    width: 800px;
    height: 400px;
    background: #FFFFFF;
    border-radius: 16px;
}
.shadowIcon{
    position: absolute;
    top: 0;
    right: -50px;
    width: 40px;
    height: 40px;
}
.shadowText1{
    position: absolute;
    top: 50px;
    width: 800px;
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #3A3A3A;
    line-height: 28px;
    text-align: center;
}
.shadowText2{
    position: absolute;
    top: 118px;
    left: 100px;
    width: 600px;
    height: 90px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #3A3A3A;
    line-height: 30px;
    text-align: justify;
    font-style: normal;
}
.shadowButton1{
    position: absolute;
    top: 306px;
    left: 243px;
    width: 150px;
    height: 44px;
    background: #CCCCCC;
    border-radius: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 22px;
    line-height: 44px;
    text-align: center;
}
.shadowButton1-s{
    position: absolute;
    top: 306px;
    left: 243px;
    width: 150px;
    height: 44px;
    background: #C49760;
    border-radius: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 22px;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
}
.shadowButton2{
    position: absolute;
    top: 306px;
    left: 408px;
    width: 150px;
    height: 44px;
    background: #FFFFFF;
    border-radius: 22px;
    border: 1px solid #C49760;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #C49760;
    line-height: 44px;
    cursor: pointer;
    text-align: center;
}
</style>